import HomePage from './pages/homepage/homepage.component';
import './App.css';
import React from 'react';

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
